import api from './api';
import { ICompany } from './companyService';

export interface RegisterUser {
  id?: string;
  login: string;
  password: string;
  nome: string;
  telefone: string;
  tipoUsuario: string;
  email: string;
  grupos: string[];
  empresas: string[];
  cpf: string;
  verTodasEmpresasNoCadastroUsuario: boolean;
  InserirMotoristasAdicionaisViagem: boolean;
}

export interface Grupo {
  descricao: string;
  dataCriacao: string;
  id: string;
}

export interface IUser {
  id: string;
  userName: string;
  nome: string;
  phoneNumber: string;
  tipoUsuario: string;
  grupos: Grupo[];
  empresas: ICompany[];
  centrosCusto: any[];
  verTodasEmpresasNoCadastroUsuario: boolean;
}

export function registerUser(data: RegisterUser) {
  return api.post('usuario', data);
}

export function updateUser(data: RegisterUser) {
  return api.put('usuario', data);
}

export function listUser(params?: any) {
  return api.get('usuario/listarusuarios', { params });
}

export function getUserById(Id: string) {
  return api.get('usuario/usuariogetbyid', { params: { Id } });
}

export const getToken = (): string | null => {
  return localStorage.getItem('token');
}

export function updateChangePassword(data: any) {
  return api.put('usuario/alterarsenha', data);
}

export function registrarUsuarioNoApp(usuarioId: string) {
  return api.post('usuario/registrar-no-app', {usuarioId:usuarioId});
}

export function AtivarOuDesativarUsuario(data: any) {
  return api.put('usuario/ativaroudesativar', data);
}

export function DesbloquearUsuario(data: any) {
  return api.put('usuario/desbloquear', data);
}
